import { useCallback } from 'react';
import { UseFormSetError } from 'react-hook-form';
import { useZodSchema } from 'shared/hooks';
import { applyMultiDayZodErrors } from '../helpers/apply-multi-day-zod-errors';
import { pickMultiDayWorkFormValidationValues } from '../helpers/pick-multi-day-work-form-validation-values';
import { createMultiDayWorkFormSchema } from '../schemas/create-multi-day-work-form.schema';
import { WorkFormContext } from '../../work-form.types';

type UseMultiDaySubmitValidationParams = {
  setError: UseFormSetError<WorkFormContext>;
};

export const useMultiDaySubmitValidation = ({ setError }: UseMultiDaySubmitValidationParams) => {
  const schema = useZodSchema(createMultiDayWorkFormSchema, 'web-common');

  const validateBeforeSubmit = useCallback(
    (data: WorkFormContext): boolean => {
      const result = schema.safeParse(pickMultiDayWorkFormValidationValues(data));

      if (result.success) {
        return true;
      }

      applyMultiDayZodErrors(result.error, setError);
      return false;
    },
    [schema, setError]
  );

  return { validateBeforeSubmit };
};
